import { useCallback } from 'react';
import Link from 'next/link';
import type { DeepReadonly } from '@itandi/itandi-bb-ui';
import { Box, Button, Flex, RiArrowRightSLine } from '@itandi/itandi-bb-ui';
import Styles from './ChatMessagePaneHeader.module.scss';
import { useMessageSelectedContext } from '~/components/common/chat/ChatPagesContainer';
import { PATH as CLIENT_PATH } from '~/pages/deals/[id]';
import { PATH as VENDOR_PATH } from '~/pages/vendors/deals/[id]';

type Props = DeepReadonly<{
  isVendor?: boolean;
  isAdmin?: boolean;
  handleTemporaryUnread: (dealId: number) => Promise<void>;
  isDisabledUnreadButton: boolean;
}>;

export const ChatMessagePaneHeader: React.FC<Props> = ({
  isVendor = false,
  isAdmin = false,
  isDisabledUnreadButton,
  handleTemporaryUnread
}: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const summary = useMessageSelectedContext().selectedSummary!;
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const setSummary = useMessageSelectedContext().setSelectedSummary!;
  const onClickClose = useCallback(
    (e: React.MouseEvent): void => {
      e.preventDefault();
      setSummary(null);
    },
    [setSummary]
  );
  const onClickTemporaryUnread = useCallback((): void => {
    handleTemporaryUnread(summary.deal.id);
    setSummary(null);
  }, [handleTemporaryUnread, summary.deal.id, setSummary]);
  return (
    <div className={Styles.HeaderContainer}>
      <h3 className={Styles.TimelineHeader}>
        <Flex>
          <Box marginTop="0.25rem">
            <Flex>
              <Box>
                <a className={Styles.CloseLink} href="#" onClick={onClickClose}>
                  <RiArrowRightSLine className={Styles.CloseIcon} />
                </a>
              </Box>
              <Box w="15rem">
                <div
                  className={Styles.RoomName}
                >{`${summary.deal.name} ${summary.deal.roomNumber}`}</div>
                <div className={Styles.PartnerName}>
                  {isVendor
                    ? summary.deal.companySetting.name
                    : summary.deal.originVendorCompany?.name}
                </div>
              </Box>
              {summary.lastSendAt !== null && (
                <Button
                  disabled={isAdmin || isDisabledUnreadButton}
                  height="small"
                  marginLeft={16}
                  onClick={onClickTemporaryUnread}
                  variant="secondary"
                >
                  未読ラベルをつける
                </Button>
              )}
            </Flex>
          </Box>
        </Flex>
      </h3>
      <div className={Styles.LinkWrapper}>
        <Link
          className={Styles.DealLink}
          href={
            isVendor
              ? VENDOR_PATH(summary.deal.id)
              : CLIENT_PATH(summary.deal.id)
          }
          target="_blank"
        >
          案件詳細
        </Link>
      </div>
    </div>
  );
};
